<template>
  <div class="index">
    <div class="slider-banner banner">
      <swiper :options="swiperOption">
        <swiper-slide v-for="(item, index) in banner" :key="index">
          <img class="swiper-img" :src="item" />
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>

    <div class="opt-list">
      <div class="opt-item" @click="nav = 0">
        <img class="opt-img" :src="`${require('@assets/images/dywfl/help1.png')}`" alt="">
        <div class="opt-title">项目介绍</div>
      </div>
      <div class="opt-item" @click="nav = 1">
        <img class="opt-img" :src="`${require('@assets/images/dywfl/help2.png')}`" alt="">
        <div class="opt-title">我要报名</div>
      </div>
      <div class="opt-item" @click="goPage('/help/child/list')">
        <img class="opt-img" :src="`${require('@assets/images/dywfl/help3.png')}`" alt="">
        <div class="opt-title">困境儿童</div>
      </div>
    </div>

    <template v-if="nav == 0">
      <img class="intro-title" :src="`${require('@assets/images/dywfl/help-title.png')}`" alt="">
      <div class="intro-container" v-html="content"></div>
    </template>
    <template v-if="nav == 1">
      <div class="form-container">
		<div class="input-box">
		  <div class="input-name">姓名：</div>
		  <input type="text" v-model="input_list.nickname" placeholder="请输入姓名" class="input-placeholder"  style="text-align: right;">
		</div>
		<div class="input-box">
		  <div class="input-name">出生年月：</div>
			<input type="text" v-model="input_list.year_month"  placeholder="请输入出生年月" class="input-placeholder" style="text-align: right;">
		</div>
		<div class="input-box">
		  <div class="input-name">职业：</div>
		  <input type="text" v-model="input_list.career" placeholder="请输入职业" class="input-placeholder" style="text-align: right;">
		</div>
		<div class="input-box">
		  <div class="input-name">区域：</div>
		  <div class="input-placeholder" @click="show_street = true">{{street_str}}</div>
		</div>
		<div class="input-box">
		  <div class="input-name">联系电话：</div>
		  <input type="tel" v-model="input_list.phone" placeholder="请输入联系电话" class="input-placeholder" style="text-align: right;">
		</div>
        <div class="confirm-btn" @click="submit">点击报名成为爱心妈妈</div>
      </div>
    </template>
	<!-- 底部占高 -->
	<div class="index-botom" style="height: 1rem"></div>
	<!-- 地区选择弹窗 -->
	<div class="mask" v-if="show_street" @click="show_street=!show_street"></div>
	<div class="area-window" v-if="show_street">
	  <div class="window-btn">
	    <div class="cancel-btn" @click="cancelWindow">取消</div>
	    <div class="confirm-btn" @click="confirmChoose">确定</div>
	  </div>
	  <div class="area-container">
	    <div class="street-list">
	      <div 
	        class="street-item" 
	        :class="street_idx == k ?'active':''" 
	        v-for="(i,k) in street_list"
	        @click="chooseStreet(k)"
	        >{{i.title}}</div>
	    </div>
	  </div>
	</div>
	<Loading :loaded="loaded" :loading="loading"></Loading>
	<Footer></Footer>
  </div>
</template>
<style>
	.intro-container p{
		 font-size: 0.32rem !important;
	}
	 .intro-container img{
		width: 100%;
		display: block;
	}
</style>
<script>
import Loading from "@components/Loading";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import {getHelpContent,getFulianCate,AddDevotion} from "@api/public";
import Footer from "@components/NewFooter";
import "@assets/css/swiper.min.css";
export default {
  name: "CateList",
  components: {
    swiper,
    swiperSlide,
	Loading,
	Footer
  },
  props: {},
  data: function () {
    return {
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function () {
            const realIndex = this.realIndex;
            vm.goUrl(realIndex);
          }
        }
      },

      nav:0,
      input_list:{
		  nickname:'',
		  year_month:'',
		  career:'',
		  region:'',
		  phone:'',
      },
	  banner:[],
	  content:[],
	  
      pid: 8, //分类id
      street_list: [], //街道列表
      street_idx:0, //街道下标
      street_id:0, //街道id
      street_str:'请选择街道',
      show_street:false,
	  
	  loaded: false,
	  loading: false,
    };
  },

  watch: {

  },
  mounted: function () {
	this.Banner();
	this.getFulianCate();
  },
  methods: {
	  getFulianCate: function () {
	    let that = this;
	    let pid = this.pid;
	    getFulianCate(pid).then((res) => {
	      let list = res.data;
	      that.$set(that, "street_list", list);
	    });
	  },
	  
	  chooseStreet(index){
	    let list = this.street_list,
	        choose_item = list[index];
	    this.street_idx = index;
	  },

	  cancelWindow(){
	    this.show_street = false
	  },
	  confirmChoose(){
	    let street_list = this.street_list,
	        street_idx = this.street_idx;
	    this.street_id = street_list[street_idx].id;
	    this.street_str = `${street_list[street_idx].title}`;
	    this.show_street = false
	  },
	  //获取轮播图/详情
	Banner(){
	  getHelpContent().then(res => {
	    this.banner=res.data.banner
	    this.content=res.data.content
	  });
	},
	//报名提交
	submit(){
		let data=this.input_list;
		data.region=this.street_str;
		data.region_id=this.street_id;
		if(!data.nickname){
			this.$dialog.error('请输入姓名');
			return;
		}
		if(!data.year_month){
			this.$dialog.error('请选择出生年月');
			return;
		}
		if(!data.career){
			this.$dialog.error('请输入职业');
			return;
		}
		if(!data.region_id || data.region_id < 1){
			this.$dialog.error('请选择街道');
			return;
		}
		if(!data.phone){
			this.$dialog.error('请输入联系电话');
			return;
		}
		if(!(/^1[3456789]\d{9}$/.test(data.phone))){
			this.$dialog.error('手机号码有误，请重填');
			return ; 
		} 
		this.$dialog.loading.open("正在加载中");
		AddDevotion(data).then((res) => {
			this.$dialog.loading.close();
			this.$dialog.success(res.msg);
			setTimeout(() => {
			  location.reload();
			}, 1000);
		}).catch(res => {
			this.$dialog.loading.close();
			this.$dialog.error(res.msg);
        });
	},
    goPage(url) {
      this.$router.push({ path: url });
    },
  },
};
</script>
<style lang="scss" scoped>
.index {
  background-color: #fceeef;
  min-height: 100vh;
  padding-bottom: .7rem;
}

.opt-list {
  background-color: #F8D8DB;
  border-radius: .1rem;
  padding: .3rem 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: .34rem .2rem 0;

  .opt-item {
    text-align: center;

    .opt-img {
      width: .83rem;
      height: .83rem;
      border-radius: 50%;
    }
  }
}

.intro-title {
  width: 100vw;
  height: 1.59rem;
  object-fit: contain;
}

.intro-container {
  margin: 0 .2rem;
  border-radius: .1rem;
  border: .03rem solid #FEBCBB;
  min-height: 7.2rem;
  background-color: #fff;
  overflow: hidden;
  font-size: 0.32rem !important;
  color: #8A8B8C !important;
  line-height: 1.8;
  word-wrap: break-word;
  word-break: normal;
}

.form-container {
  margin: .38rem .2rem;
  border-radius: .1rem;
  border: .03rem solid #FEBCBB;
  background-color: #fff;
  padding: 0 .3rem .6rem;

  .input-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: .77rem;
    background-color: #FFEDEE;
    padding: 0 .3rem;
    border-radius: .1rem;
    margin-top: .4rem;

    .input-placeholder {
      color: #666;

    }
  }

  .confirm-btn {
    border-radius: .85rem;
    background-color: #F64272;
    color: #fff;
    text-align: center;
    line-height: .85rem;
    margin-top: .6rem;
  }
}
.area-window {
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 556;
  width: 100vw;
  height: 50%;

  .window-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: .3rem;
    font-size: .3rem;
    line-height: 1;
    border-bottom: 1px solid #EFEFEF;
    font-size: .3rem;
    .cancel-btn {}

    .confirm-btn {
      color: #F64272;
    }
  }

  .area-container{
    height: calc(50vh - 0.9rem);
    .street-list{
      min-width: 2.77rem;
      background-color: #EFEFEF;
      flex-shrink: 0;
      height: 100%;
      overflow-y: auto;
      .street-item{
        line-height: 1rem;
        text-align: center;
        font-size: .3rem;
        &.active{
          background-color: #fff;
          color: #F64272;
        }
      }
    }
    .comm-list{
      flex: 1;
      padding-left: .5rem;
      height: 100%;
      overflow-y: auto;
      .comm-item{
        padding: .25rem 0;
        font-size: .3rem;
        line-height: 1;
        &.active{
          color: #F64272;
        }
      }
    }
  }
}
</style>
